webpackJsonp([1,0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(73);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(72);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _vueEvents = __webpack_require__(39);
	
	var _vueEvents2 = _interopRequireDefault(_vueEvents);
	
	var _App = __webpack_require__(57);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _firebase = __webpack_require__(1);
	
	var _firebase2 = _interopRequireDefault(_firebase);
	
	var _numeral = __webpack_require__(4);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	var _languages = __webpack_require__(3);
	
	var _languages2 = _interopRequireDefault(_languages);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _Dashboard = __webpack_require__(62);
	
	var _Dashboard2 = _interopRequireDefault(_Dashboard);
	
	var _LeagueAdmin = __webpack_require__(6);
	
	var _LeagueAdmin2 = _interopRequireDefault(_LeagueAdmin);
	
	var _LeagueEdit = __webpack_require__(68);
	
	var _LeagueEdit2 = _interopRequireDefault(_LeagueEdit);
	
	var _League = __webpack_require__(5);
	
	var _League2 = _interopRequireDefault(_League);
	
	var _Countries = __webpack_require__(59);
	
	var _Countries2 = _interopRequireDefault(_Countries);
	
	var _Fishes = __webpack_require__(65);
	
	var _Fishes2 = _interopRequireDefault(_Fishes);
	
	var _PeopleAdmin = __webpack_require__(69);
	
	var _PeopleAdmin2 = _interopRequireDefault(_PeopleAdmin);
	
	var _CountryDataPoints = __webpack_require__(61);
	
	var _CountryDataPoints2 = _interopRequireDefault(_CountryDataPoints);
	
	var _Periods = __webpack_require__(70);
	
	var _Periods2 = _interopRequireDefault(_Periods);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueEvents2.default);
	_vue2.default.use(_vueRouter2.default);
	var router = new _vueRouter2.default({
	  hashbang: false,
	  history: true
	});
	
	router.map({
	  '/dashboard': {
	    component: _Dashboard2.default
	  },
	  '/leagues': {
	    component: _LeagueAdmin2.default
	  },
	  '/leagues/:key': {
	    component: _League2.default
	  },
	  '/leagues/:key/edit': {
	    component: _LeagueEdit2.default
	  },
	  '/leagues/:key/:lang': {
	    component: _League2.default
	  },
	  '/countries': {
	    component: _Countries2.default
	  },
	  '/data': {
	    component: _CountryDataPoints2.default
	  },
	  '/fish': {
	    component: _Fishes2.default
	  },
	  '/people': {
	    component: _PeopleAdmin2.default
	  },
	  '/periods': {
	    component: _Periods2.default
	  }
	});
	
	router.redirect({
	  '*': '/dashboard'
	});
	
	var config = {
	  apiKey: "apiKey",
	  authDomain: "overfishing-50a52.firebaseapp.com",
	  databaseURL: "https://overfishing-50a52.firebaseio.com",
	  storageBucket: 'gs://overfishing-50a52.appspot.com'
	};
	_firebase2.default.initializeApp(config);
	
	_vue2.default.filter('fishImg', function (value) {
	  if (value.en) {
	    var fishImgPath = '/static/img/fish/blue/';
	    return fishImgPath + value.en.replace(/\s+/g, '-') + '_' + value.la.replace(/\s+/g, '-') + '.png';
	  }
	});
	
	_vue2.default.filter('flagImg', function (value) {
	  if (value) {
	    var flagImgPath = '/static/img/flags/';
	    return flagImgPath + value.replace(/\s+/g, '-') + '.png';
	  }
	});
	
	_vue2.default.filter('formatTonnes', function (value) {
	  if (value) {
	    return (0, _numeral2.default)(value).format('0,0');
	  }
	});
	
	_vue2.default.filter('ordinal', function (value, lang) {
	  if (value) {
	    if (lang == 'en') {
	      return (0, _numeral2.default)(value).format('0o').replace(value, '');
	    } else {
	      return '.';
	    }
	  }
	});
	
	_vue2.default.filter('quotaOver', function (dataPoint) {
	  return (0, _numeral2.default)(dataPoint.quotaSet - dataPoint.quotaAdvice).format(0.);
	});
	
	_vue2.default.filter('percentOver', function (dataPoint) {
	  return Math.round(100 / dataPoint.quotaAdvice * dataPoint.quotaSet - 100) + "%";
	});
	
	_vue2.default.filter('languageFromCode', function (code) {
	  return _underscore2.default.indexBy(_languages2.default, 'code')[code].title;
	});
	
	Array.prototype.insert = function (index, item) {
	  this.splice(index, 0, item);
	};
	
	var Alert = {
	  install: function install(Vue) {
	    Vue.prototype.$alert = function (msg) {
	      this.$events.fire('alert', msg);
	    };
	  }
	};
	_vue2.default.use(Alert);
	
	router.start(_App2.default, 'app');

/***/ },
/* 1 */,
/* 2 */,
/* 3 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = [{
	  title: "Albanian",
	  code: "sq"
	}, {
	  title: "Arabic",
	  code: "ar"
	}, {
	  title: "Armenian",
	  code: "hy"
	}, {
	  title: "Bulgarian",
	  code: "bg"
	}, {
	  title: "Catalan",
	  code: "ca"
	}, {
	  title: "Chinese",
	  code: "zh"
	}, {
	  title: "Chuvash",
	  code: "cv"
	}, {
	  title: "Danish",
	  code: "da"
	}, {
	  title: "Dutch",
	  code: "nl"
	}, {
	  title: "Estonian",
	  code: "et"
	}, {
	  title: "Finnish",
	  code: "fi"
	}, {
	  title: "French",
	  code: "fr"
	}, {
	  title: "Galician",
	  code: "gl"
	}, {
	  title: "Georgian",
	  code: "ka"
	}, {
	  title: "German",
	  code: "de"
	}, {
	  title: "Greek",
	  code: "el"
	}, {
	  title: "Hebrew",
	  code: "he"
	}, {
	  title: "Hindi",
	  code: "hi"
	}, {
	  title: "Hungarian",
	  code: "hu"
	}, {
	  title: "Icelandic",
	  code: "is"
	}, {
	  title: "Irish",
	  code: "ga"
	}, {
	  title: "Italian",
	  code: "it"
	}, {
	  title: "Japanese",
	  code: "ja"
	}, {
	  title: "Korean",
	  code: "ko"
	}, {
	  title: "Kurdish",
	  code: "ku"
	}, {
	  title: "Latvian",
	  code: "lv"
	}, {
	  title: "Lithuanian",
	  code: "lt"
	}, {
	  title: "Macedonian",
	  code: "mk"
	}, {
	  title: "Manx",
	  code: "gv"
	}, {
	  title: "Moldavian",
	  code: "mo"
	}, {
	  title: "Northern Sami",
	  code: "se"
	}, {
	  title: "Norwegian",
	  code: "no"
	}, {
	  title: "Persian",
	  code: "fa"
	}, {
	  title: "Polish",
	  code: "pl"
	}, {
	  title: "Portuguese",
	  code: "pt"
	}, {
	  title: "Romanian",
	  code: "ro"
	}, {
	  title: "Russian",
	  code: "ru"
	}, {
	  title: "Sardinian",
	  code: "sc"
	}, {
	  title: "Serbian",
	  code: "sr"
	}, {
	  title: "Slovak",
	  code: "sk"
	}, {
	  title: "Slovenian",
	  code: "sl"
	}, {
	  title: "Spanish",
	  code: "es"
	}, {
	  title: "Swedish",
	  code: "sv"
	}, {
	  title: "Thai",
	  code: "th"
	}, {
	  title: "Tonga (Tonga Islands)",
	  code: "to"
	}, {
	  title: "Turkish",
	  code: "tr"
	}, {
	  title: "Ukrainian",
	  code: "uk"
	}, {
	  title: "Welsh",
	  code: "cy"
	}];

/***/ },
/* 4 */,
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(34)
	__vue_script__ = __webpack_require__(18)
	__vue_template__ = __webpack_require__(54)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__vue_script__ = __webpack_require__(20)
	__vue_template__ = __webpack_require__(49)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 7 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = [{
	  "country": "Austria",
	  "code": "AT"
	}, {
	  "country": "Belgium",
	  "code": "BE"
	}, {
	  "country": "Bulgaria",
	  "code": "BG"
	}, {
	  "country": "Croatia",
	  "code": "HR"
	}, {
	  "country": "Cyprus",
	  "code": "CY"
	}, {
	  "country": "Czech Republic",
	  "code": "CZ"
	}, {
	  "country": "Denmark",
	  "code": "DK"
	}, {
	  "country": "Estonia",
	  "code": "EE"
	}, {
	  "country": "Finland",
	  "code": "FI"
	}, {
	  "country": "France",
	  "code": "FR"
	}, {
	  "country": "Germany",
	  "code": "DE"
	}, {
	  "country": "Greece",
	  "code": "EL"
	}, {
	  "country": "Hungary",
	  "code": "HU"
	}, {
	  "country": "Iceland",
	  "code": "IS"
	}, {
	  "country": "Ireland",
	  "code": "IE"
	}, {
	  "country": "Italy",
	  "code": "IT"
	}, {
	  "country": "Latvia",
	  "code": "LV"
	}, {
	  "country": "Liechtenstein",
	  "code": "LI"
	}, {
	  "country": "Lithuania",
	  "code": "LT"
	}, {
	  "country": "Luxembourg",
	  "code": "LU"
	}, {
	  "country": "Malta",
	  "code": "MT"
	}, {
	  "country": "Netherlands",
	  "code": "NL"
	}, {
	  "country": "Norway",
	  "code": "NO"
	}, {
	  "country": "Poland",
	  "code": "PL"
	}, {
	  "country": "Portugal",
	  "code": "PT"
	}, {
	  "country": "Romania",
	  "code": "RO"
	}, {
	  "country": "Slovakia",
	  "code": "SK"
	}, {
	  "country": "Slovenia",
	  "code": "SI"
	}, {
	  "country": "Spain",
	  "code": "ES"
	}, {
	  "country": "Sweden",
	  "code": "SE"
	}, {
	  "country": "Switzerland",
	  "code": "CH"
	}, {
	  "country": "United Kingdom",
	  "code": "UK"
	}];

/***/ },
/* 8 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ["Anchovy - Engraulis encrasicolus", "Anglerfish - Lophiidae", "Atlantic salmon - Salmo salar", "Blue ling - Molva dypterygia", "Blue whiting - Micromesistius poutassou", "Bluefin tuna - Thunnus thynnus", "Boarfish - Caproidae", "Cod - Gadus morhua", "Dab - Limanda limanda", "Greenland halibut - Reinhardtius hippoglossoides", "Haddock - Melanogrammus aeglefinus", "Hake - Merluccius merluccius", "Herring - Clupea harengus", "Horse mackerel - Trachurus", "Lemon sole - Microstomus kitt", "Ling - Molva molva", "Mackerel - Scomber scombrus", "Megrims - Lepidorhombus", "Northern prawn - Pandalus borealis", "Norway lobster - Nephrops norvegicus", "Norway pout - Trisopterus esmarkii", "Plaice - Pleuronectes platessa", "Pollack - Pollachius pollachius", "Porbeagle - Lamna nasus", "Redfish - Sebastes", "Roundnose granadier - Coryphaenoides rupestris", "Saithe - Pollachius virens", "Sandeel - Ammodytes", "Skates and rays - Rajiformes", "Sole - Solea solea", "Spiny dogfish - Squalus acanthias", "Sprat - Sprattus sprattus", "Swordfish - Xiphias gladius", "Turbot - Psetta maxima", "Tusk - Brosme brosme", "Whiting - Merlangius merlangus"];

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Alert = __webpack_require__(58);
	
	var _Alert2 = _interopRequireDefault(_Alert);
	
	var _League = __webpack_require__(5);
	
	var _League2 = _interopRequireDefault(_League);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    League: _League2.default,
	    Alert: _Alert2.default
	  }
	};

/***/ },
/* 10 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  data: function data() {
	    return {
	      msg: ""
	    };
	  },
	  ready: function ready() {
	    var self = this;
	
	    this.$events.$on('alert', function (msg) {
	      self.msg = msg;
	      setTimeout(function () {
	        self.msg = null;
	      }, 2000);
	    });
	  }
	};

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _firebase = __webpack_require__(1);
	
	var _firebase2 = _interopRequireDefault(_firebase);
	
	var _countries = __webpack_require__(7);
	
	var _countries2 = _interopRequireDefault(_countries);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      countries: []
	    };
	  },
	  ready: function ready() {
	    window.fb = _firebase2.default;
	    window.countryList = _countries2.default;
	    window._ = _underscore2.default;
	
	    self = this;
	    _firebase2.default.database().ref('countries').on('child_added', function (snapshot) {
	      var country = snapshot.val();
	      country.key = snapshot.key;
	      self.countries.push(country);
	    });
	  }
	};

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _firebase = __webpack_require__(1);
	
	var _firebase2 = _interopRequireDefault(_firebase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    key: null,
	    lang: null
	  },
	  data: function data() {
	    return {
	      country: {}
	    };
	  },
	  ready: function ready() {
	    var self = this;
	
	    _firebase2.default.database().ref('countries/' + this.key).on('value', function (snapshot) {
	      self.country = snapshot.val();
	    });
	  }
	};

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _firebase = __webpack_require__(1);
	
	var _firebase2 = _interopRequireDefault(_firebase);
	
	var _DataPointForm = __webpack_require__(63);
	
	var _DataPointForm2 = _interopRequireDefault(_DataPointForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    DataPointForm: _DataPointForm2.default
	  },
	  data: function data() {
	    return {
	      countryDataPoints: [],
	      openModalKey: false,
	      countries: [],
	      years: [],
	      regions: [],
	      people: [],
	      newDataPoint: {
	        region: 0,
	        year: 2014
	      }
	    };
	  },
	  ready: function ready() {
	    var self = this;
	    this.fetchYears();
	    this.fetchCountries();
	    this.fetchPeople();
	    this.fetchRegions();
	
	    _firebase2.default.database().ref('countryDataPoints').on('child_added', function (snapshot) {
	      var dataPoint = snapshot.val();
	      dataPoint.key = snapshot.key;
	      self.countryDataPoints.push(dataPoint);
	      console.log(self.countryDataPoints);
	    });
	  },
	  methods: {
	    openEdit: function openEdit(key) {
	      this.openModalKey = key;
	    },
	    closeEdit: function closeEdit(e) {
	      e.cancelBubble = true;
	      this.openModalKey = false;
	    },
	    fetchCountries: function fetchCountries() {
	      var self = this;
	
	      _firebase2.default.database().ref('countries').on('child_added', function (snapshot) {
	        var country = snapshot.val();
	        country.key = snapshot.key;
	        self.countries.push(country);
	      });
	    },
	
	    fetchPeople: function fetchPeople() {
	      var self = this;
	
	      _firebase2.default.database().ref('people').on('child_added', function (snapshot) {
	        var person = snapshot.val();
	        person.key = snapshot.key;
	        self.people.push(person);
	      });
	    },
	
	    fetchRegions: function fetchRegions() {
	      var self = this;
	
	      _firebase2.default.database().ref('regions').on('child_added', function (snapshot) {
	        var region = snapshot.key;
	        self.regions.push(region);
	      });
	    },
	
	    fetchYears: function fetchYears() {
	      var self = this;
	
	      _firebase2.default.database().ref('periods').on('child_added', function (snapshot) {
	        self.years.push(snapshot.key);
	      });
	    }
	  }
	};

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _LeagueAdmin = __webpack_require__(6);
	
	var _LeagueAdmin2 = _interopRequireDefault(_LeagueAdmin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {};

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _firebase = __webpack_require__(1);
	
	var _firebase2 = _interopRequireDefault(_firebase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ["countries", "years", "people", "regions", "dataPoint"],
	  data: function data() {
	    return {};
	  },
	  ready: function ready() {},
	  methods: {
	    addDataPoint: function addDataPoint() {
	      var self = this;
	
	      var dataPointRef = _firebase2.default.database().ref('countryDataPoints').push();
	      dataPointRef.set(this.dataPoint, function (err) {
	        if (err) return;
	        self.dataPoint.quotaOver = null;
	        self.dataPoint.percentOver = null;
	        self.dataPoint.countryKey = 0;
	        self.dataPoint.peopleKeys = 0;
	      });
	    },
	
	    deleteDataPoint: function deleteDataPoint(key) {
	      _firebase2.default.database().ref('countryDataPoints/' + key).set(null);
	    },
	
	    updateDataPoint: function updateDataPoint(dataPoint) {
	      var dataPointRef = _firebase2.default.database().ref('countryDataPoints/' + dataPoint.key);
	      dataPointRef.set(dataPoint);
	    }
	  }
	};

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _firebase = __webpack_require__(1);
	
	var _firebase2 = _interopRequireDefault(_firebase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    key: null,
	    lang: null
	  },
	  data: function data() {
	    return {
	      fish: {}
	    };
	  },
	  ready: function ready() {
	    var self = this;
	
	    _firebase2.default.database().ref('fishes/' + this.key).on('value', function (snapshot) {
	      self.fish = snapshot.val();
	    });
	  }
	};

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _firebase = __webpack_require__(1);
	
	var _firebase2 = _interopRequireDefault(_firebase);
	
	var _fishes = __webpack_require__(8);
	
	var _fishes2 = _interopRequireDefault(_fishes);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      fishes: []
	    };
	  },
	  ready: function ready() {
	    window.fb = _firebase2.default;
	    window.fishList = _fishes2.default;
	    window._ = _underscore2.default;
	
	    self = this;
	    _firebase2.default.database().ref('fishes').on('child_added', function (snapshot) {
	      var fish = snapshot.val();
	      fish.key = snapshot.key;
	      self.fishes.push(fish);
	    });
	  },
	  methods: {
	    fishImg: function fishImg(fish) {
	      var fishImgPath = '/static/img/fish/blue/';
	      return fishImgPath + fish.en.replace(/\s+/g, '-') + '_' + fish.la.replace(/\s+/g, '-') + '.png';
	    }
	  }
	};

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Fish = __webpack_require__(64);
	
	var _Fish2 = _interopRequireDefault(_Fish);
	
	var _Country = __webpack_require__(60);
	
	var _Country2 = _interopRequireDefault(_Country);
	
	var _Person = __webpack_require__(71);
	
	var _Person2 = _interopRequireDefault(_Person);
	
	var _firebase = __webpack_require__(1);
	
	var _firebase2 = _interopRequireDefault(_firebase);
	
	var _fileSaver = __webpack_require__(37);
	
	var _domToImage = __webpack_require__(26);
	
	var _domToImage2 = _interopRequireDefault(_domToImage);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _numeral = __webpack_require__(4);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	
	  components: {
	    Fish: _Fish2.default,
	    Country: _Country2.default,
	    Person: _Person2.default
	  },
	
	  data: function data() {
	    return {
	      lang: null,
	      league: null,
	      dataPoints: [],
	      namedMinisters: 0
	    };
	  },
	
	  ready: function ready() {
	    var self = this;
	
	    if (this.$route.params.lang) {
	      this.lang = this.$route.params.lang;
	    } else {
	      this.lang = 'en';
	    }
	
	    _firebase2.default.database().ref('leagues').child(this.$route.params.key).on('value', function (snapshot) {
	      self.league = snapshot.val();
	      self.getData();
	    });
	  },
	
	  methods: {
	
	    getData: function getData() {
	      var self = this;
	      console.log('Getting data: ', this.league.year, this.league.region);
	      var dataPointsRef = _firebase2.default.database().ref('countryDataPoints').orderByChild('region').equalTo(this.league.region).on('value', function (snapshot) {
	        var dataPoints = snapshot.val();
	
	        _underscore2.default.each(dataPoints, function (dataPoint, i) {
	          if (dataPoint.year == self.league.year) {
	            dataPoint.percentOver = 100 / dataPoint.quotaAdvice * dataPoint.quotaSet - 100;
	            self.dataPoints.push(dataPoint);
	          }
	        });
	
	        var count = self.$route.query.count;
	        if (count) {
	          self.dataPoints = _underscore2.default.sortBy(self.dataPoints, "percentOver").reverse().slice(0, count);
	        } else {
	          self.dataPoints = _underscore2.default.sortBy(self.dataPoints, "percentOver").reverse();
	        }
	
	        self.fetchPeople();
	      });
	    },
	
	    fetchPeople: function fetchPeople() {
	      var self = this;
	
	      _underscore2.default.each(self.dataPoints, function (dataPoint) {
	        _firebase2.default.database().ref('people').child(dataPoint.peopleKeys).on('value', function (snapshot) {
	          console.log(snapshot.val());
	          var minister = snapshot.val();
	          if (minister.name && minister.name.trim().length > 0) self.namedMinisters++;
	        });
	      });
	    },
	
	    download: function download() {
	      console.log("Downloading...");
	      var el = document.getElementById('league'),
	          scale = 3;
	
	      _domToImage2.default.toBlob(el, {
	        quality: 1,
	        width: el.clientWidth * scale,
	        height: el.clientHeight * scale,
	        bgcolor: '#ffffff',
	        style: {
	          'transform': 'scale(' + scale + ')',
	          'transform-origin': 'top left'
	        }
	      }).then(function (blob) {
	        (0, _fileSaver.saveAs)(blob, 'league.png');
	      });
	    }
	  }
	};

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _firebase = __webpack_require__(1);
	
	var _firebase2 = _interopRequireDefault(_firebase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      league: {
	        languages: ["en"],
	        en: {
	          title: "",
	          subtitle: "",
	          countryLabel: "Country",
	          ministerLabel: "Minister",
	          quotaLabel: "Quota",
	          quotaUnitLabel: "Tonnes",
	          fishLabel: "Species fished above scientific advice"
	        }
	      }
	    };
	  },
	  methods: {
	    add: function add() {
	      var leagueRef = _firebase2.default.database().ref('leagues').push();
	      this.league.createdAt = Date.now();
	      leagueRef.set(this.league);
	      console.log("Added league");
	    }
	  }
	};

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _firebase = __webpack_require__(1);
	
	var _firebase2 = _interopRequireDefault(_firebase);
	
	var _LeagueAdd = __webpack_require__(66);
	
	var _LeagueAdd2 = _interopRequireDefault(_LeagueAdd);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    LeagueAdd: _LeagueAdd2.default
	  },
	  data: function data() {
	    return {
	      leagues: []
	    };
	  },
	  ready: function ready() {
	    var self = this;
	    _firebase2.default.database().ref('leagues').on('child_added', function (snapshot) {
	      var league = snapshot.val();
	      league.key = snapshot.key;
	      self.leagues.push(league);
	    });
	  },
	  methods: {
	    deleteLeague: function deleteLeague(league) {
	      _firebase2.default.database().ref('leagues/' + league.key).set(null);
	    }
	  }
	};

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _firebase = __webpack_require__(1);
	
	var _firebase2 = _interopRequireDefault(_firebase);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    region: null,
	    year: null,
	    lang: null
	  },
	  data: function data() {
	    return {
	      countries: {},
	      leagueCountries: []
	    };
	  },
	  ready: function ready() {
	    var self = this;
	
	    _firebase2.default.database().ref('countries').once('value').then(function (snapshot) {
	      self.countries = snapshot.val();
	
	      _firebase2.default.database().ref('countryDataPoints').orderByChild('region').equalTo(self.region).once('value').then(function (snapshot) {
	        var regionData = snapshot.val();
	
	        _underscore2.default.each(regionData, function (regionDataPoint) {
	          if (regionDataPoint.year == self.year) {
	            var key = regionDataPoint.countryKey;
	            self.leagueCountries.push(self.countries[key]);
	          }
	        });
	      });
	    });
	
	    this.$on('update', function () {
	      if (this.lang != 'en') {
	        _firebase2.default.database().ref('countries').update(this.countries);
	      }
	    });
	  }
	};

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _LeagueCountries = __webpack_require__(67);
	
	var _LeagueCountries2 = _interopRequireDefault(_LeagueCountries);
	
	var _firebase = __webpack_require__(1);
	
	var _firebase2 = _interopRequireDefault(_firebase);
	
	var _languages = __webpack_require__(3);
	
	var _languages2 = _interopRequireDefault(_languages);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	
	  components: {
	    LeagueCountries: _LeagueCountries2.default
	  },
	
	  data: function data() {
	    return {
	      league: null,
	      languages: _languages2.default,
	      key: this.$route.params.key,
	      newLanguage: 0,
	      newFish: null,
	      years: [],
	      regions: [],
	      fishes1: {}
	    };
	  },
	
	  ready: function ready() {
	    var self = this;
	
	    _firebase2.default.database().ref('leagues/' + this.key).once('value').then(function (snapshot) {
	      self.league = snapshot.val();
	    }).then(function () {
	      self.fetchYears();
	      self.fetchRegions();
	      self.fetchFish();
	    });
	  },
	
	  methods: {
	
	    update: function update() {
	      var leagueRef = _firebase2.default.database().ref('leagues').child(this.key);
	      leagueRef.set(this.league);
	      this.updateFishes();
	      this.$broadcast('update');
	      this.$alert('Updated');
	    },
	
	    updateFishes: function updateFishes() {
	      var self = this;
	      var fishUpdateRef = {};
	      _underscore2.default.each(this.league.fishes, function (value, key) {
	        fishUpdateRef[key] = self.fishes1[key];
	      });
	      _firebase2.default.database().ref('fishes/').update(fishUpdateRef);
	    },
	
	    addLanguage: function addLanguage() {
	      var lang = this.newLanguage;
	      if (lang) {
	        var league = this.league;
	        league.languages.push(lang);
	        league[lang] = league.en;
	
	        var leagueRef = _firebase2.default.database().ref('leagues').child(this.key);
	        leagueRef.set(league);
	      }
	    },
	
	    deleteLanguage: function deleteLanguage(language) {
	      var league = this.league;
	
	      league.languages = _underscore2.default.filter(league.languages, function (lang) {
	        return lang != language;
	      });
	      league[language] = null;
	
	      var leagueRef = _firebase2.default.database().ref('leagues').child(this.key);
	      leagueRef.set(league);
	    },
	
	    addFish: function addFish() {
	      var fish = this.newFish;
	      if (!this.league.fishes) {
	        this.league.fishes = {};
	      }
	      this.league.fishes[fish] = true;
	      this.update();
	    },
	
	    deleteFish: function deleteFish(fishKey) {
	      this.league.fishes[fishKey] = null;
	      this.update();
	    },
	
	    fetchFish: function fetchFish() {
	      var self = this;
	
	      _firebase2.default.database().ref('fishes').on('value', function (snapshot) {
	        self.fishes1 = snapshot.val();
	      });
	    },
	
	    fetchRegions: function fetchRegions() {
	      var self = this;
	
	      _firebase2.default.database().ref('regions').on('child_added', function (snapshot) {
	        var region = snapshot.key;
	        self.regions.push(region);
	      });
	    },
	
	    fetchYears: function fetchYears() {
	      self = this;
	      _firebase2.default.database().ref('periods').on('child_added', function (snapshot) {
	        self.years.push(snapshot.key);
	      });
	    }
	  }
	};

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _firebase = __webpack_require__(1);
	
	var _firebase2 = _interopRequireDefault(_firebase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      people: {},
	      person: {},
	      openModalKey: false
	    };
	  },
	  ready: function ready() {
	    var self = this;
	
	    _firebase2.default.database().ref('people').on('value', function (snapshot) {
	      self.people = snapshot.val();
	    });
	  },
	  methods: {
	    openEdit: function openEdit(key) {
	      this.openModalKey = key;
	    },
	
	    closeEdit: function closeEdit(e) {
	      e.cancelBubble = true;
	      this.openModalKey = false;
	    },
	
	    save: function save(key) {
	      var ref = _firebase2.default.database().ref('people/' + key);
	      console.log(this.people[key]);
	      ref.update(this.people[key]);
	      this.$alert('Dunnit.');
	    },
	
	    fileSelected: function fileSelected(personKey, e) {
	      var self = this;
	      var file = e.target.files[0];
	      var ref = firebase.storage().ref('people');
	      var ext = file.name.match(/\.[0-9a-z]+$/i);
	      var personRef = ref.child(Date.now() + ext);
	      var uploadTask = personRef.put(file);
	
	      uploadTask.on('state_changed', null, null, function () {
	        var downloadUrl = uploadTask.snapshot.downloadURL;
	
	        if (personKey) {
	          self.people[personKey].photo = downloadUrl;
	        } else {
	          self.person.photo = downloadUrl;
	        }
	      });
	    },
	
	    add: function add() {
	      console.log('adding person: ', this.person);
	      var personRef = _firebase2.default.database().ref('people').push();
	      personRef.set(this.person);
	    },
	
	    deletePerson: function deletePerson(personKey, person) {
	      _firebase2.default.database().ref('people/' + personKey).set(null);
	      if (person.photo) {
	        _firebase2.default.storage().refFromURL(person.photo).delete();
	      }
	    },
	
	    deletePhoto: function deletePhoto(personKey) {
	      _firebase2.default.storage().refFromURL(this.people[personKey].photo).delete();
	      this.people[personKey].photo = null;
	    }
	  }
	};

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _firebase = __webpack_require__(1);
	
	var _firebase2 = _interopRequireDefault(_firebase);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      periods: []
	    };
	  },
	  ready: function ready() {
	    window.fb = _firebase2.default;
	    window._ = _underscore2.default;
	
	    self = this;
	    _firebase2.default.database().ref('periods').on('child_added', function (snapshot) {
	      self.periods.push(snapshot.key);
	    });
	  }
	};

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _firebase = __webpack_require__(1);
	
	var _firebase2 = _interopRequireDefault(_firebase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    key: null
	  },
	  data: function data() {
	    return {
	      person: {}
	    };
	  },
	  ready: function ready() {
	    var self = this;
	
	    _firebase2.default.database().ref('people/' + this.key).on('value', function (snapshot) {
	      self.person = snapshot.val();
	    });
	  }
	};

/***/ },
/* 26 */,
/* 27 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 28 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 29 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 30 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 31 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 32 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 33 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 34 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 35 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 36 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */
/***/ function(module, exports) {

	module.exports = " <div id=app> <alert></alert> <router-view></router-view> </div> ";

/***/ },
/* 41 */
/***/ function(module, exports) {

	module.exports = " <div class=alert v-show=msg transition=expand>{{msg}}</div> ";

/***/ },
/* 42 */
/***/ function(module, exports) {

	module.exports = " <div class=\"country-admin section\"> <h1 class=title>Countries</h1> <div> <div class=media v-for=\"country in countries\"> <div class=media-left> <img v-bind:src=\"'/static/img/flags/'+country.en.name.replace(' ', '-')+'.png'\"/> </div> <h2 class=subtitle>{{country.en.name}}</h2> {{country |json}} </div> </div> </div> ";

/***/ },
/* 43 */
/***/ function(module, exports) {

	module.exports = " <div class=country v-if=country> <img :src=\"country.en.name | flagImg\"/> {{country[lang].name}} </div> ";

/***/ },
/* 44 */
/***/ function(module, exports) {

	module.exports = " <div class=\"dashboard section\"> <h1 class=title>Overfishing</h1> <h2 class=subtitle>Dashboard</h2> <aside class=menu> <ul class=\"menu-list is-large\"> <li><a v-link=\"{path:'/leagues'}\">Leagues</a></li> <li><a v-link=\"{path:'/people'}\">People</a></li> <li><a v-link=\"{path:'/data'}\">Data</a></li> <p class=menu-label>Presets</p> <li><a v-link=\"{path:'/fish'}\">Fish</a></li> <li><a v-link=\"{path:'/countries'}\">Countries</a></li> </ul> </aside> </div> ";

/***/ },
/* 45 */
/***/ function(module, exports) {

	module.exports = " <div class=add-data-point> <label class=label>Country</label> <span class=select> <select v-model=dataPoint.countryKey> <option disabled=disabled hidden selected={{!dataPoint.countryKey}}>Select country</option> <option v-for=\"country in countries\" v-bind:value=country.key selected=\"{{dataPoint.countryKey == country.key}}\">{{country.en.name}}</option> </select> </span> <span class=select> <select v-model=dataPoint.year> <option v-for=\"year in years\">{{year}}</option> </select> </span> <span class=select> <select v-model=dataPoint.region> <option disabled=disabled hidden selected={{!dataPoint.region}}>Select region</option> <option v-for=\"region in regions\" selected=\"{{dataPoint.region == region}}\">{{region}}</option> </select> </span> <label class=label>Quota advice</label> <input v-model=dataPoint.quotaAdvice type=number placeholder=\"Quota advice\" class=input number/> <label class=label>Quota set at</label> <input v-model=dataPoint.quotaSet type=number placeholder=\"Quota set\" class=input number/> <span class=select> <select v-model=dataPoint.peopleKeys> <option disabled=disabled hidden selected={{!dataPoint.peopleKeys}}>Select people...</option> <option v-for=\"person in people\" v-bind:value=person.key selected=\"{{dataPoint.peopleKeys == person.key}}\"> {{person.name}} </option> </select> </span> <button v-on:click=addDataPoint v-if=!dataPoint.key class=\"button is-primary\">Add datapoint </button> <button v-on:click=updateDataPoint(dataPoint) v-if=dataPoint.key class=\"button is-success\">Update datapoint </button> </div> ";

/***/ },
/* 46 */
/***/ function(module, exports) {

	module.exports = " <div class=fish> <img :src=\"fish | fishImg\"/><br> <span>{{fish[lang]}}</span> </div> ";

/***/ },
/* 47 */
/***/ function(module, exports) {

	module.exports = " <div class=\"fish-admin section\"> <h1 class=title>Fish</h1> <div class=fishes> <article class=\"fish media\" v-for=\"fish in fishes\"> <div class=media-left> <img v-bind:src=fishImg(fish) /> </div> <div class=media-content> <h2 class=subtitle>{{fish.en}} <small><em>{{fish.la}}</em></small></h2> </div> </article> </div> </div> ";

/***/ },
/* 48 */
/***/ function(module, exports) {

	module.exports = " <div class=\"add-league level\"> <input v-model=league.en.title type=text placeholder=\"League title\" class=input /> <input v-model=league.en.subtitle type=text placeholder=Subtitle class=input /> <button v-on:click=add class=\"button is-primary\"> Add new league </button> </div> ";

/***/ },
/* 49 */
/***/ function(module, exports) {

	module.exports = " <div class=\"league-admin section\"> <div class=level> <div class=level-left> <h1 class=title>Leagues</h1> </div> <div class=level-right> <league-add></league-add> </div> </div> <div class=leagues> <div class=\"media level\" v-for=\"league in leagues\"> <a v-link=\"{ path: '/leagues/' + league.key }\"> <h2 class=subtitle> {{ league.en.title }} {{league.en.subtitle}} </h2> </a> <a v-link=\"{ path: '/leagues/' + league.key + '/edit' }\" class=button> Edit </a> <button @click=deleteLeague(league) class=\"button is-danger\">Delete</button>  </div> </div> </div>";

/***/ },
/* 50 */
/***/ function(module, exports) {

	module.exports = " <div class=league-countries> <template v-for=\"(key, country) in leagueCountries\"> <span v-if=\"lang == 'en'\" class=\"tag is-medium is-primary\">{{country.en.name}}</span> <input v-model=country[lang].name v-else :value=country[lang].name :placeholder=country.en.name class=input /> </template> </div> ";

/***/ },
/* 51 */
/***/ function(module, exports) {

	module.exports = " <div class=\"edit-league section\"> <template v-if=league> <div class=level> <div class=level-left> <h1 class=title>Edit {{ league.en.title }}</h1> </div> <div class=level-right> <div class=\"control is-grouped\"> <p class=\"add-language control\"> </p><div class=\"control has-addons\"> <span class=select> <select v-model=newLanguage class=form-control> <option disabled=disabled hidden selected={{!newLanguage}}>Select...</option> <option v-for=\"language in languages\" v-bind:value=language.code> {{ language.title }} </option> </select> </span> <button v-on:click=addLanguage class=\"button is-primary\">Add language</button> </div> <p></p> <p class=control> <button v-on:click=update class=\"button is-success\">Update</button> </p> </div> </div> </div> <div class=lang v-for=\"lang in league.languages\"> <h2 class=subtitle v-if=\"lang != 'en'\"> {{lang | languageFromCode}} <small v-on:click=deleteLanguage(lang)>Delete</small> </h2> <div class=\"control is-grouped\"> <p class=\"control is-expanded\"> <label class=label>Title</label> <input v-model=league[lang].title type=text placeholder=\"League title\" class=input /> </p> <p class=\"control is-expanded\"> <label class=label>Subtitle</label> <input v-model=league[lang].subtitle type=text placeholder=Subtitle class=input /> </p> </div> <label class=label>Labels</label> <div class=\"control is-grouped\"> <p class=\"control is-expanded\"> <input v-model=league[lang].countryLabel type=text placeholder=\"Country label\" class=input /> </p> <p class=\"control is-expanded\"> <input v-model=league[lang].ministerLabel type=text placeholder=\"Minister label\" class=input /> </p> <p class=\"control is-expanded\"> <input v-model=league[lang].quotaLabel type=text placeholder=\"Quota label\" class=input /> </p> <p class=\"control is-expanded\"> <input v-model=league[lang].quotaUnitLabel type=text placeholder=\"Quota unit label\" class=input /> </p> <p class=\"control is-expanded\"> <input v-model=league[lang].fishLabel type=text placeholder=\"Fish species label\" class=input /> </p> </div> <div v-if=\"lang == 'en'\"> <label class=label>Year</label> <p class=control> <span class=select> <select v-model=league.year> <option>Select year...</option> <option v-for=\"year in years\" number>{{ year }}</option> </select> </span> </p> <label class=label>Region</label> <p class=control> <span class=select> <select v-model=league.region> <option>Select region...</option> <option v-for=\"region in regions\" number>{{ region }}</option> </select> </span> </p> </div> <div class=countries> <label class=label>Countries <small>(Generated from data)</small></label> <div> <league-countries :region=league.region :year=league.year :lang=lang></league-countries> </div> </div> <div class=fish-species v-if=fishes1> <label class=label>Fish</label> <div> <span class=\"tag is-primary is-medium\" v-for=\"(key, fish) in league.fishes\" v-if=\"lang == 'en'\"> {{key}} <button v-on:click=deleteFish(key) class=delete></button> </span> <div class=add-fish v-if=\"lang == 'en'\"> <div class=\"control has-addons\"> <span class=select> <select v-model=newFish> <option disabled=disabled hidden selected={{!newFish}}>Select...</option> <option v-for=\"fish in fishes1\"> {{ fish.en }} </option> </select> </span> <button v-on:click=addFish class=\"button is-primary\">Add fish</button> </div> </div> </div> <div v-if=\"lang != 'en'\"> <p v-for=\"(key, fish) in league.fishes\"> <input v-model=fishes1[key][lang] class=input :placeholder=key v-if=fishes1 /> </p> </div> </div> </div> <p class=control> <button v-on:click=update class=\"button is-success\">Update</button> </p> </template> </div> ";

/***/ },
/* 52 */
/***/ function(module, exports) {

	module.exports = " <div class=\"fish-admin section\"> <h1 class=title>Periods</h1> <div class=fishes> <article class=\"fish media\" v-for=\"(periodVal, period) in periods\"> <div class=media-content> <h2 class=subtitle>{{period}}</h2> </div> </article> </div> </div> ";

/***/ },
/* 53 */
/***/ function(module, exports) {

	module.exports = " <div class=person> <div class=person-thumb :style=\"'background-image:url(\\'' + person.photo + '\\')'\"></div> {{person.name}} {{person.twitter}} </div> ";

/***/ },
/* 54 */
/***/ function(module, exports) {

	module.exports = " <div class=league id=league v-on:click=download _v-0f9705cc=\"\"> <template v-if=league> <header _v-0f9705cc=\"\"> <div class=title _v-0f9705cc=\"\">{{league[lang].title}}</div><br _v-0f9705cc=\"\"> <div class=subtitle _v-0f9705cc=\"\">{{league[lang].subtitle}}</div> </header> <table _v-0f9705cc=\"\"> <thead _v-0f9705cc=\"\"> <tr _v-0f9705cc=\"\"> <th _v-0f9705cc=\"\"></th> <th _v-0f9705cc=\"\">{{league[lang].countryLabel}}</th> <th v-if=\"namedMinisters > 0\" _v-0f9705cc=\"\">{{league[lang].ministerLabel}}</th> <th class=quota _v-0f9705cc=\"\">{{league[lang].quotaLabel}}</th> </tr> </thead> <tbody _v-0f9705cc=\"\"> <tr class=bg-waves _v-0f9705cc=\"\"> <td colspan=4 _v-0f9705cc=\"\"></td> </tr> <tr v-for=\"(index, dataPoint) in dataPoints\" _v-0f9705cc=\"\"> <td _v-0f9705cc=\"\"> <h2 class=\"rank font-steagal-bold\" _v-0f9705cc=\"\">{{index+1}}<sup class=f05 _v-0f9705cc=\"\">{{index+1 | ordinal lang}}</sup></h2> </td> <td _v-0f9705cc=\"\"> <h2 class=rank _v-0f9705cc=\"\"> <country :key=dataPoint.countryKey :lang=lang _v-0f9705cc=\"\"></country> </h2> </td> <td v-if=\"namedMinisters > 0\" _v-0f9705cc=\"\"> <h2 class=\"person italic\" _v-0f9705cc=\"\"> <person :key=dataPoint.peopleKeys _v-0f9705cc=\"\"></person> </h2> </td> <td class=quota _v-0f9705cc=\"\"> <h2 class=quota _v-0f9705cc=\"\">{{dataPoint | percentOver}}</h2> <h3 class=quota-label _v-0f9705cc=\"\">{{dataPoint | quotaOver}} {{league[lang].quotaUnitLabel}}</h3> </td> </tr> </tbody> </table> <footer _v-0f9705cc=\"\"> <div class=columns _v-0f9705cc=\"\"> <div class=\"column is-10 is-offset-1\" _v-0f9705cc=\"\"> <h2 _v-0f9705cc=\"\">{{league[lang].fishLabel}}</h2> <div class=\"fishes level\" _v-0f9705cc=\"\"> <div v-for=\"(key, fish) in league.fishes\" class=fish _v-0f9705cc=\"\"> <fish :key=key :lang=lang _v-0f9705cc=\"\"></fish> </div> </div> <img src=/static/img/nef_logo.png class=nef-logo _v-0f9705cc=\"\"><br _v-0f9705cc=\"\"> <a class=\"nef-link black\" href=http://neweconomics.org _v-0f9705cc=\"\">neweconomics.org</a> </div> </div> </footer> </template> </div> ";

/***/ },
/* 55 */
/***/ function(module, exports) {

	module.exports = " <div class=\"country-data section\" _v-1ae104d6=\"\"> <h1 class=title _v-1ae104d6=\"\">Country data</h1> <div class=box _v-1ae104d6=\"\"> <data-point-form :countries=countries :data-point=newDataPoint :regions=regions :years=years :people=people _v-1ae104d6=\"\"> </data-point-form> </div> <div _v-1ae104d6=\"\"> <div v-for=\"dataPoint in countryDataPoints\" class=box @click=openEdit(dataPoint.key) _v-1ae104d6=\"\"> <strong _v-1ae104d6=\"\">{{dataPoint.region}} - {{dataPoint.year}}</strong> {{dataPoint.countryKey}} ({{dataPoint | quotaOver}} tonnes - {{dataPoint | percentOver}}) <div :class=\"['modal', {'is-active': (dataPoint.key == openModalKey)}]\" _v-1ae104d6=\"\"> <div class=modal-background @click=closeEdit _v-1ae104d6=\"\"></div> <div class=modal-card _v-1ae104d6=\"\"> <header class=modal-card-head _v-1ae104d6=\"\"> <p class=modal-card-title _v-1ae104d6=\"\">Edit data point</p> <button class=delete @click=closeEdit _v-1ae104d6=\"\"></button> </header> <section class=modal-card-body _v-1ae104d6=\"\"> <data-point-form :data-point=dataPoint :countries=countries :regions=regions :years=years :people=people _v-1ae104d6=\"\"> </data-point-form> </section> <footer class=modal-card-foot _v-1ae104d6=\"\"> <a class=\"button is-primary\" _v-1ae104d6=\"\">Save</a> <a class=button @click=closeEdit _v-1ae104d6=\"\">Cancel</a> </footer> </div> </div> </div> </div> </div> ";

/***/ },
/* 56 */
/***/ function(module, exports) {

	module.exports = " <div class=\"people section\" _v-e01aa19a=\"\"> <div class=container _v-e01aa19a=\"\"> <h1 class=title _v-e01aa19a=\"\">People</h1> <div class=\"add-person container box\" _v-e01aa19a=\"\"> <h2 class=subtitle _v-e01aa19a=\"\">Add minister</h2> <div class=level _v-e01aa19a=\"\"> <input type=file @change=\"fileSelected(null, $event)\" _v-e01aa19a=\"\"> <input v-model=person.name type=text placeholder=\"Minister name\" class=input _v-e01aa19a=\"\"> <input v-model=person.twitter type=text placeholder=Twitter class=input _v-e01aa19a=\"\"> <button v-on:click=add class=\"button is-primary\" :disabled=!person.photo _v-e01aa19a=\"\"> Add minister </button> </div> </div> <div _v-e01aa19a=\"\"> <div class=media v-for=\"(key, person) in people\" @click=openEdit(key) _v-e01aa19a=\"\"> <div class=media-left _v-e01aa19a=\"\"> <figure class=\"image is-128x128\" _v-e01aa19a=\"\"> <img v-bind:src=person.photo _v-e01aa19a=\"\"> </figure> </div> <div class=media-content _v-e01aa19a=\"\"> <h2 class=subtitle _v-e01aa19a=\"\">{{person.name}}</h2> {{person.twitter}} <div _v-e01aa19a=\"\"> <button @click=\"deletePerson(key, person)\" class=\"button is-danger is-pulled-right\" _v-e01aa19a=\"\">Delete</button> </div> </div> <div :class=\"['modal', {'is-active': (key == openModalKey)}]\" _v-e01aa19a=\"\"> <div class=modal-background @click=closeEdit _v-e01aa19a=\"\"></div> <div class=modal-card _v-e01aa19a=\"\"> <header class=modal-card-head _v-e01aa19a=\"\"> <p class=modal-card-title _v-e01aa19a=\"\">Edit person</p> <button class=delete @click=closeEdit _v-e01aa19a=\"\"></button> </header> <section class=modal-card-body _v-e01aa19a=\"\"> <input type=file @change=\"fileSelected(key, $event)\" v-show=!person.photo _v-e01aa19a=\"\"> <figure class=\"image is-128x128\" v-show=person.photo :title=person.photo _v-e01aa19a=\"\"> <img v-bind:src=person.photo _v-e01aa19a=\"\"> </figure> <button v-show=person.photo class=\"button is-danger\" @click=deletePhoto(key) _v-e01aa19a=\"\">Delete photo</button> <input v-model=person.name type=text placeholder=\"Minister name\" class=input _v-e01aa19a=\"\"> <input v-model=person.twitter type=text placeholder=Twitter class=input _v-e01aa19a=\"\"> </section> <footer class=modal-card-foot _v-e01aa19a=\"\"> <a class=\"button is-success\" @click=save(key) _v-e01aa19a=\"\">Save</a> <a class=button @click=closeEdit _v-e01aa19a=\"\">Cancel</a> </footer> </div> </div> </div> </div> </div> </div> ";

/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(28)
	__vue_script__ = __webpack_require__(9)
	__vue_template__ = __webpack_require__(40)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(29)
	__vue_script__ = __webpack_require__(10)
	__vue_template__ = __webpack_require__(41)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__vue_script__ = __webpack_require__(11)
	__vue_template__ = __webpack_require__(42)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(27)
	__vue_script__ = __webpack_require__(12)
	__vue_template__ = __webpack_require__(43)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(35)
	__vue_script__ = __webpack_require__(13)
	__vue_template__ = __webpack_require__(55)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(30)
	__vue_script__ = __webpack_require__(14)
	__vue_template__ = __webpack_require__(44)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__vue_script__ = __webpack_require__(15)
	__vue_template__ = __webpack_require__(45)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__vue_script__ = __webpack_require__(16)
	__vue_template__ = __webpack_require__(46)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(31)
	__vue_script__ = __webpack_require__(17)
	__vue_template__ = __webpack_require__(47)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__vue_script__ = __webpack_require__(19)
	__vue_template__ = __webpack_require__(48)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__vue_script__ = __webpack_require__(21)
	__vue_template__ = __webpack_require__(50)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(32)
	__vue_script__ = __webpack_require__(22)
	__vue_template__ = __webpack_require__(51)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(36)
	__vue_script__ = __webpack_require__(23)
	__vue_template__ = __webpack_require__(56)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__vue_script__ = __webpack_require__(24)
	__vue_template__ = __webpack_require__(52)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(33)
	__vue_script__ = __webpack_require__(25)
	__vue_template__ = __webpack_require__(53)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ }
]);


/** WEBPACK FOOTER **
 ** static/js/app.996074a0b433eb5f6eea.js
 **/